/* eslint-disable */
import i18nFindLocaleByLang from '../FindLocaleByLang/I18nFindLocaleByLang.support';

/**
 * Determine if a provided `lang` exists in the given `locales`
 * @export
 * @param {I18nEntityLangs} lang The `lang` to check
 * @param {Array<I18nEntityLocale>} locales The `locales` to check against
 * @returns {boolean} Whether or not the provided `lang` is indeed valid
 */
const i18nValidateLangExists = (lang, locales) => {
  // If we can't find the `locale`, the following line will throw, and therefore, the `lang` does not exist
  i18nFindLocaleByLang(lang, locales);
  return true;
};

export default i18nValidateLangExists;
